export default __webpack_public_path__ + "static/media/frame-img.5156a1de.jpg";